import { callApiV3Get } from 'utilities/apiCaller';
import API from 'constants/api';
import { TransportMode } from 'constants/modes';

const getAllPayToParties = async (countryCode: string, companyCode: string, purchaseOrganisation: string) => {
	try {
		const response = await callApiV3Get(
			API.Vendors.GetVendors,
			{
				'country': countryCode,
				'companyCode': companyCode,
				'purchaseOrg': purchaseOrganisation
			},
			{
				headers: {
					TransportMode: TransportMode.Ocean
				}
			}
		);
		return response.data;
	} catch (error) {
		console.error('Error fetching vendors data:', error);
		throw error;
	}
};

export default {
	getAllPayToParties,
};